import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import {
  BookOutlined,
  BuildOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  GlobalOutlined,
  HeartOutlined,
  HomeOutlined,
  RiseOutlined,
  SwapOutlined,
  SyncOutlined,
  TeamOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';

const { Paragraph, Title } = Typography;

const domains = [
  {
    title: 'Domain 1 – Atmospheric Reactive and Greenhouse Gases',
    copy: 'To monitor atmospheric reactive and green-house gases, their transport, and assess their impact on climate change.',
  },
  {
    title: 'Domain 2 – Urban Planning and Solid Waste Management',
    copy: 'Urban planning with particular emphasis on solid waste management, gases emissions and their impact on ecology.',
  },
  {
    title: 'Domain 3 – Land-use/Landcover',
    copy: 'To assess the Land-use/Landcover (LULC) changes, water crises, and their impact on climate change.',
  },
  {
    title: 'Domain 4 – Natural and Anthropogenic Aerosols',
    copy: 'To monitor natural and anthropogenic aerosols, track transboundary aerosols, and assess their radiative impact on climate change.',
  },
];

const sdgs = [
  ['Good Health and Wellbeing', HeartOutlined],
  ['Quality Education', BookOutlined],
  ['Gender Equality', TeamOutlined],
  ['Clean Water and Sanitation', ExperimentOutlined],
  ['Affordable and Clean Energy', ThunderboltOutlined],
  ['Decent Work and Economic Growth', RiseOutlined],
  ['Industry, Innovation and Infrastructure', BuildOutlined],
  ['Reduced Inequality', SwapOutlined],
  ['Sustainable Cities and Communities', HomeOutlined],
  ['Responsible Consumption and Production', SyncOutlined],
  ['Climate Action', GlobalOutlined],
  ['Life On Land', EnvironmentOutlined],
];

const ResearchDomains = () => (
  <section className="research-domains-section sdssl-research-domains-section">
    <div className="research-domains-inner">
      <Row gutter={[72, 40]} justify="space-between" align="top">
        <Col xs={24} lg={15}>
          <Title level={2} className="research-domains-title">Research Domains</Title>
          <Divider className="ncgsa-divider" />
          <Paragraph className="research-domain-copy">
            Tools, technologies, and scientific approaches related to GIS and Space Applications would be utilized
          </Paragraph>
          {domains.map((domain) => (
            <div className="research-domain" key={domain.title}>
              <Title level={5} className="research-domain-title">{domain.title}</Title>
              <Paragraph className="research-domain-copy">{domain.copy}</Paragraph>
            </div>
          ))}
        </Col>
        <Col xs={24} lg={8}>
          <Title level={2} className="research-domains-title">Focused SDGs</Title>
          <Divider className="ncgsa-divider" />
          <ul className="sdg-focus-list">
            {sdgs.map(([label, Icon]) => (
              <li key={label}>
                <span className="sdg-focus-icon" aria-hidden="true"><Icon /></span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  </section>
);

export default ResearchDomains;
